import { render, staticRenderFns } from "./OrganizeTab2.vue?vue&type=template&id=06cb3a32&"
import script from "./OrganizeTab2.vue?vue&type=script&lang=js&"
export * from "./OrganizeTab2.vue?vue&type=script&lang=js&"
import style0 from "./OrganizeTab2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports